import { subscribe, disposeContext } from "./messageSubscriber";
import { dedupeMixin } from "@open-wc/dedupe-mixin";
import { decoratedListeners } from "./subscriberDecorator";
let self = this || window;
if (!self.HTMLElement)
    self.HTMLElement = class {
    };
function _SMSElementMix(Base) {
    if (!Base)
        return;
    return class extends Base {
        subscribe(subj, handler) {
            return subscribe(subj, handler, this);
        }
        constructor(...args) {
            super(...args);
            let decorated = Array.from(decoratedListeners.keys()).filter(k => this instanceof k);
            for (let dec of decorated) {
                let list = decoratedListeners.get(dec);
                for (let l of list) {
                    let subs = subscribe(l.subject, this[l.listener], this);
                    if (l.sendLastState)
                        subs.sendLastState();
                }
            }
        }
        disposeSMS() {
            disposeContext(this);
        }
        disconnectedCallback() {
            disposeContext(this);
            let dc = super["disconnectedCallback"];
            if (dc && typeof dc === "function")
                dc.bind(this)();
        }
    };
}
export const SMSElementMix = dedupeMixin(_SMSElementMix);
export class SMSElement extends SMSElementMix(HTMLElement) {
}
